import React from "react";
import SubEfficeSlash from "graphics/icons/SubEfficeSlash";
import PrettySubEfficeNumber from "./PrettySubEfficeNumber/PrettySubEfficeNumber";
import { goToEffice } from "slices/efficeTreeSlice";
import "tippy.js/animations/shift-away.css";
import NtfyDotDark from "graphics/icons/NtfyDotDark";
import EfsTippy from "components/HOCS/EfsTippy";

const BranchOff = ({ efficeData, notify }) => {
  if (efficeData.content === null || efficeData.failed || efficeData.pending) {
    return null;
  }

  return (
    <EfsTippy
      content="See Thread"
      placement="right"
      className="normal-Tippy"
      delay={[300, 0]}
    >
      <div
        className={`Txt-effice-subs ${
          efficeData.sub_effices > 0 ? "" : "Txt-effice-no-subs"
        }`}
        onClick={() => {
          goToEffice(efficeData.id);
        }}
      >
        <>
          <div className="Txt-effice-sub-slash">
            <SubEfficeSlash />
          </div>
          <div className={`Txt-effice-sub-number ${notify ? "notify" : ""}`}>
            <PrettySubEfficeNumber number={efficeData.sub_effices} />
          </div>
          {notify ? (
            <>
              &nbsp;&nbsp;&nbsp;
              <NtfyDotDark />
            </>
          ) : null}
        </>
      </div>
    </EfsTippy>
  );
};

export default BranchOff;
